<template lang="pug">
  .component-client-controller
    .row
      .columns.small-12.large-6
        driver(:type="'driver-card'", :item="item.main_driver")

      .columns.small-12.large-6
        .card
          .row
            .column.m-1
              .label Status
              .field-value {{item.status}}
          .row
            .column
              loading-spinner(v-if="checkLoader")
              .card(v-if="checkedData && showCheck ")
                .row(v-html="showObject(null, checkedData)" class="columnizer")

              .button.small.m-1.float-left(v-if="!showCheck" v-on:click="loadCheckedData('quick')") Quick Check
              .button.small.m-1.float-right(v-if="!showCheck" v-on:click="loadCheckedData('complete')") Complete Check
              .button.small.m-1.float-right(v-else v-on:click="showHideCheckButton") Hide Data
    .container
      .balance(v-if="$acl('balance-billing')")
        loading-spinner(v-if="balanceLoader")
        Cards(:data="clientMetrics", v-else)
      .row
        .columns.small-6
          client(:type="'highlightedNotes'", :item="item")
      .row.column
        router-tab-headers#client-details(:tabs="tabs", :id="'client-detail'", :activeIndex="0", :deepLink="true")
          router-view


</template>
<script type="text/babel">
  import RouterTabHeaders from 'components/structure/foundation/RouterTabHeaders'
  import Driver from 'components/backoffice/Driver'
  import Client from 'components/backoffice/Client'
  import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
  import Cards from '../../../components/structure/Cards'
  import LoadingSpinner from '../../../components/structure/LoadingSpinner'
  import Card3 from "../../../components/structure/Card3";

  export default {
    name: 'ClientController',
    components: {
      Card3,
      LoadingSpinner,
      Cards,
      Client,
      Driver,
      RouterTabHeaders
    },
    data() {
      return {
        tabs: [
          {
            headerName: 'Profile',
            name: 'client',
            pathName: 'profile'
          },
          {
            headerName: 'Drivers',
            name: 'client-drivers',
            pathName: 'drivers'
          },
        ],
        balance: null,
        balanceLoader: false,
        checkLoader: false,
        checkedData: null,
        showCheck: false
      }

    },
    mounted() {
    },

    created() {
      this.balanceLoader = true
      const aclMap = new Map([
        ['booking', {
          headerName: 'Reservations',
          name: 'client-reservations',
          pathName: 'reservations'
        }],
        ['get-client-subscriptions-subscriptions', {
          headerName: 'Subscriptions',
          name: 'client-subscriptions',
          pathName: 'subscriptions'
        }],
        ['index-transactions', {
          headerName: 'Transactions',
          name: 'client-transactions',
          pathName: 'transactions'
        }],
        ['payment-methods-clients', {
          headerName: 'Payment methods',
          name: 'client-payment-methods',
          pathName: 'payment-methods'
        }],
        ['balance-billing', {
          headerName: 'Billing',
          name: 'client-wallets',
          pathName: 'wallets'
        }],
        ['cards-clients', {
          headerName: 'Cards',
          name: 'client-cards',
          pathName: 'client-cards'
        }],
        ['index-log', {
          headerName: 'Logs',
          name: 'client-logs',
          pathName: 'client-logs'
        }],
        ['index-log', {
          headerName: 'Logs',
          name: 'client-logs',
          pathName: 'client-logs'
        }]
      ])
      aclMap.forEach((val, key) => {
        if (this.$acl(key)) {
          this.tabs.push(val)
        }
      })

      if (this.$acl('balance-billing')) {
        KeplerBackofficeSdk.credits.select(this.item).balance((data) => {
          this.balance = data
          this.balanceLoader = false
        }, () => {
          this.balanceLoader = false
        })
      }
    },
    methods: {
      showObject(k, obj, columnClass = 'columns small-6 large-6') { //debugger
        self = this
        let ret = ''
        if (k) {
          ret = ret + '<div class="' + columnClass + '">'
          ret = ret + '<span>' + this.cleanKey(k) + '</span>'
          ret = ret + "<div style='padding-left:10px'>" + this.showObject(null, obj, '') + "</div>"
          ret = ret + '</div>'
          return ret
        }
        if (obj)
          Object.keys(obj).forEach((i) => {
            if (Array.isArray(obj[i])) {
              ret = ret + this.showArray(i, obj[i], columnClass)
            } else if (typeof obj[i] === 'object') {
              ret = ret + this.showObject(i, obj[i], columnClass)
            } else
              ret = ret + this.showString(i, obj[i], columnClass)

          })
        return ret
      },
      showString(k, v, columnClass) {
        if (k == 'No problems found') {
          return '<div class="' + columnClass + '"><span>' + this.cleanKey(k) + '</span></div>'
        }
        return '<div class="' + columnClass + '"><span>' + this.cleanKey(k) + '</span>: ' + v + '</div>'
      },
      showArray(k, a, columnClass) {
        return '<div class="' + columnClass + '"><span>' + this.cleanKey(k) + '</span>: <br> ' + a.join(", ") + '</div>'
      },
      cleanKey(k) {
        return k.replace(/-/g, ' ').replace(/_/g, ' ')
      },
      showHideCheckButton() {
        this.showCheck = !this.showCheck
      },

      loadCheckedData(lookupType) {
        this.checkLoader = true

        KeplerBackofficeSdk.clients.select(this.item).checkClientData((data) => {
          if (!Object.keys(data).length) {
            data = {'No problems found': ''}
          }
          this.checkedData = data
          this.checkLoader = false
        }, () => {
          this.checkLoader = false
        }, lookupType)

        this.showHideCheckButton()
        return this.checkedData
      }
    },
    computed: {
      clientMetrics() {
        if (this.balance === null) {
          return []
        }

        return [
          {
            title: 'Promo Credit',
            value: this.$priceWithcurrency(this.balance.promo)
          },
          {
            title: 'Paid Credit',
            value: this.$priceWithcurrency(this.balance.credit)
          },
          {
            title: 'Wallet balance',
            value: this.$priceWithcurrency(this.balance.wallets)
          },
          {
            title: 'Unpaid Invoices',
            value: this.$priceWithcurrency(this.balance.invoices)
          },
          {
            title: 'Uninvoiced Records',
            value: this.$priceWithcurrency(this.balance.uninvoiced)
          },
        ]
      }
    },
    props: ['item'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">

  .columnizer
    padding-left: 20px

  .columnizer > div
    margin-bottom: 10px

  .columnizer span
    text-transform: capitalize
    color: #626262

  .columnizer > div > span
      text-transform: uppercase
      font-weight: bold
      color: #5EB9CF

  .client-subscriptions
    margin: 10px

    .client-reservations
      margin: 10px

    .client-profile
      margin: 20px

    .client-drivers
      margin: 20px

</style>



// WEBPACK FOOTER //
// Client.vue?58de6a3a